var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.file
    ? _c(
        "div",
        {
          staticClass: "chat-media-upload-preview pa-2",
          attrs: { "data-test": "media-upload-preview" }
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "cancel-btn",
              attrs: {
                disabled: _vm.isUploading,
                "data-test": "media-cancel",
                icon: "",
                "x-small": ""
              },
              on: { click: _vm.onCancel }
            },
            [
              _c("icon-svg", {
                attrs: { name: _vm.icons.close, size: "12", color: "#8E8E8E" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "d-flex align-center" }, [
            _c("div", { staticClass: "preview-thumb mr-3" }, [
              _vm.isImage && _vm.thumbnailUrl
                ? _c("img", {
                    staticClass: "preview-image rounded",
                    attrs: { src: _vm.thumbnailUrl, alt: _vm.fileName }
                  })
                : _vm.isVideo && _vm.thumbnailUrl
                ? _c(
                    "video",
                    {
                      staticClass: "preview-image rounded",
                      attrs: { src: _vm.thumbnailUrl }
                    },
                    [_c("track", { attrs: { kind: "captions" } })]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "preview-icon d-flex align-center justify-center rounded"
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: _vm.fileIcon,
                          size: "24",
                          color: "grey darken-1"
                        }
                      })
                    ],
                    1
                  )
            ]),
            _c("div", { staticClass: "flex-grow-1 overflow-hidden pr-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "az-text-primary az-size-12 font-medium text-truncate"
                },
                [_vm._v(" " + _vm._s(_vm.fileName) + " ")]
              ),
              _c("div", { staticClass: "az-text-secondary az-size-12" }, [
                _vm._v(" " + _vm._s(_vm.fileSize) + " ")
              ]),
              _c("input", {
                ref: "captionInput",
                staticClass: "caption-input az-text-primary az-size-12 mt-1",
                attrs: {
                  "data-test": "media-caption",
                  type: "text",
                  placeholder: "Adicionar legenda..."
                },
                domProps: { value: _vm.caption },
                on: { input: _vm.onCaptionInput, keydown: _vm.onCaptionKeydown }
              })
            ])
          ]),
          _vm.progress !== null
            ? _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      value: _vm.progress,
                      "data-test": "upload-progress",
                      height: "4",
                      rounded: "",
                      color: _vm.uploadComplete ? "success" : "primary"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }